'use strict';

var $ = require('jquery');
var Cookies = require('js-cookie');

var VISIBLE_CLASS = 'is-visible';
var AOC_FADE = 'aoc-fade';
var AOC_FADE_TIME = '1';
var SELECTORS = {
    MESSAGE: '.js-aoc',
    MESSAGE_BUTTON: '.js-aoc__close'
};

document.documentElement.style.setProperty('--aoc-fade-time', `${AOC_FADE_TIME}s`);

function showMessage(elem) {
    elem.addClass(VISIBLE_CLASS);

    setTimeout(() => {
        elem.addClass(AOC_FADE);
    }, 1)
}

function hideMessage(elem) {
    elem.removeClass(AOC_FADE);
    
    setTimeout(() => {
        elem.removeClass(VISIBLE_CLASS);
    }, `${AOC_FADE_TIME * 1000}`)
}

function init() {
    var messages = $(SELECTORS.MESSAGE);
    if (messages.length) {
        messages.each(function() {
            var message = $(this);
            var messageId = message.data('messageId');
            var messageStorageKey = 'app.message-hidden-' + messageId;
            var isHidden = parseInt(Cookies.get(messageStorageKey), 10) || 0;

            if (!isHidden) {
                showMessage(message);
            }

            var callback = function() {
                hideMessage(message);

                Cookies.set(messageStorageKey, 1, {
                    path: '/',
                    expires: 3
                });
            }

            setTimeout(() => {
                $(window).on('click scroll', callback);
            }, 500) // to let page load a bit
        });
    }
}

module.exports = {
    init: init
};
